export default __webpack_public_path__ + "static/media/enjoy.f6df16ef.jpg";